// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"heart"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M4.19633 12.1965C2.15461 10.1548 2.15461 6.84451 4.19634 4.80278C6.23806 2.76105 9.54836 2.76105 11.5901 4.80278L12.0008 5.21354L12.4108 4.80429C14.4525 2.76256 17.7628 2.76256 19.8046 4.80429C21.8463 6.84602 21.8463 10.1563 19.8046 12.198L12 20.0011L4.19633 12.1965Z","fillRule":"evenodd","clipRule":"evenodd"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M4.19633 12.1965C2.15461 10.1548 2.15461 6.84451 4.19634 4.80278C6.23806 2.76105 9.54836 2.76105 11.5901 4.80278L12.0008 5.21354L12.4108 4.80429C14.4525 2.76256 17.7628 2.76256 19.8046 4.80429C21.8463 6.84602 21.8463 10.1563 19.8046 12.198L12 20.0011L4.19633 12.1965Z","fillRule":"evenodd","strokeLinecap":"square","strokeWidth":"props.strokeWidth","clipRule":"evenodd"}}]}]};

const HeartIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'heart',
    ref,
    icon: element,
  },
));

HeartIcon.displayName = 'HeartIcon';

export default HeartIcon;
